<template>
    <div>
        <rkm-form
            v-if="loaded"
            ref="Form"
            show-legend
        >
            <rkm-area
                title="Paciente"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="5">
                        <rkm-form-input
                            disabled
                            label="Nome"
                            v-model="form.paciente.nome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-input
                            disabled
                            label="Prontuário"
                            v-model="form.paciente.prontuario"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Idade"
                            v-model="form.paciente.idade"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-input
                            disabled
                            label="Data de nascimento"
                            v-model="form.paciente.dataNascimento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-area
                            no-margin-top
                            title="Telefones"
                        >
                            <template v-slot:trailing>
                                <rkm-button
                                    @click="$refs.ModalTelefone.open(form.paciente)"
                                    color="primary"
                                    small
                                    title="Editar"
                                >
                                    <rkm-icon icon="pen" />
                                </rkm-button>
                            </template>

                            <CidadaoTelefone
                                :telefones="form.paciente.telefones"
                                readonly
                            />
                        </rkm-area>
                    </rkm-col>
                </rkm-row>
            </rkm-area>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-date-picker
                        :max-date="additionals.dataAtual"
                        :validations="validations.data"
                        v-model="model.data"
                        label="Data"
                    />
                </rkm-col>

                <rkm-col cols="8">
                    <rkm-form-input-autocomplete
                        :repository="repositories.usuario"
                        :search-fields="[{ key: 'cadastro_cidadao.nome', searchable: true }]"
                        label="Usuário"
                        text-field="cidadaoNome"
                        v-model="model.usuario"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        label="Detalhes"
                        v-model="model.detalhes"
                        :validations="validations.detalhes"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalTelefone ref="ModalTelefone" />
    </div>
</template>

<script>
// Components.
import ModalTelefone from './components/telefone/Modal'
import CidadaoTelefone from '@/components/cadastro/cidadao/Telefone'

// Mixins.
import { repository, error, data, object, stringCase, formats, unmask, file } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Others.
import moment from 'moment'

export default {
    components: { ModalTelefone, CidadaoTelefone },
    computed: {
        validations() {

            return {
                data: { required: true },
                detalhes: { max: 500 },
            }
        },
        telefonePrincipal() {

            const telefonePrincipal = this.form.paciente.telefones.find(t => t.principal)

            return telefonePrincipal ? this.formatPhoneOrCellPhone(telefonePrincipal.numero) : null
        }
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            impressao: this.getConectaSusRepository('impressao.regulacao')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        additionals: null,
        form: null,
        model: null,
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fila.createTentativaContato(this.solicitacao.id)
                .then(({ data }) => {

                    data.model.data = this.others.moment(data.model.data, 'DD/MM/YYYY').toDate()

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                this.setLoading()

                this.repositories.fila.storeTentativaContato(this.prepareData())
                    .then(({ data }) => {

                        this.showConfirmation('Deseja imprimir a tentativa de contato?',
                            async () => {

                                this.print(data)
                                this.$emit('save')
                            },
                            async () => this.$emit('save')
                        )
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        prepareData() {

            const data = this.clone(this.model)

            data.solicitacaoId = this.solicitacao.id

            this.formateDates(data, ['data'], 'DD/MM/YYYY')
            this.createIdKeysToObject(data, ['usuario'])

            data.paciente = {
                telefones: this.clone(this.form.paciente.telefones).map(telefone => {

                    telefone.numero = this.unMaskPhone(telefone.numero)

                    return telefone
                })
            }

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        print(tentativaContato) {

            this.setLoading()

            this.repositories.impressao.tentativaContato(tentativaContato.id)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, error, data, object, stringCase, formats, unmask, file],
    props: {
        solicitacao: { type: Object, required: true },
    },
}
</script>